// extracted by mini-css-extract-plugin
module.exports = {"Droppable":"Droppable_Droppable__1qYXh","dragging":"Droppable_dragging__2tE_S","over":"Droppable_over__RgTtd","dropped":"Droppable_dropped__O6WO9"};